import type { ListContext } from '@/lib/eventBus/trackingEvents'

interface SelectedItemList {
  productCode: string
  listContext: ListContext
}

export const PRODUCT_PAGE_ITEM_INDEX = 0

const PRODUCT_DETAILS_LIST: ListContext = { kind: 'productDetails' }

let lastSelectedItemList: SelectedItemList | null = null

export const rememberSelectedItemList = (productCode: string, listContext: ListContext) => {
  lastSelectedItemList = { productCode, listContext }
}

/** The list the user clicked the product in; the product page itself after a direct load or an untracked link. */
export const getProductPageItemList = (productCode?: string): ListContext => {
  const selected = lastSelectedItemList

  return selected != null && selected.productCode === productCode ? selected.listContext : PRODUCT_DETAILS_LIST
}
